import {addEvent} from "../../utils/events/events";
import {onReady} from "../../utils/events/onReady";
import {Loader} from "@googlemaps/js-api-loader";

export class BranchOverview {
    /**

     * Internal placeholder for DOM-objects

     *

     * @type {object}

     * @ignore

     */

    dom = {
        container: undefined
    };

    /**

     *

     * @param {Element} domReference - The element to work from

     */

    constructor(domReference) {
        this.dom.container = domReference;

        this.loader = new Loader({
            apiKey: "AIzaSyAAEQ1evP_ReoYlV_rOT1MgXXGz4uEdv-U",
            version: "weekly"
        });
        onReady(() => this.init(domReference));
    }

    loadMap() {
        this.loader.load().then(() => {
            this.map = new google.maps.Map(document.getElementById("map"), {
                center: {lat: 56.2639, lng: 9.5018},
                zoom: 7,
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            });

            let infowindow = new google.maps.InfoWindow({
                content: "",
                maxWidth: 550
            });

            this.dom.container
                .querySelectorAll(".branch-overview__card")
                .forEach(bank => {
                    let phoneHtml = "";
                    let phone = bank.dataset.phone;
                    if (phone !== "0") {
                        phoneHtml = `<p><b>Telefon: </b>${phone}</p>`;
                    }

                    let openingHours = "";

                    let dataOpeningHours = JSON.parse(bank.dataset.openinghours)
                    let dataNoOpeningHours = JSON.parse(bank.dataset.noopeninghours)
                    let dataOpeningHours3 = JSON.parse(bank.dataset.openinghours3)

                    for (let i = 0; i < dataOpeningHours.length; i++) {
                        openingHours += `<p>${dataOpeningHours[i]}</p>`;
                    }

                    for (let i = 0; i < dataNoOpeningHours.length; i++) {
                        openingHours += `<p>${dataNoOpeningHours[i]}</p>`;
                    }

                    for (let i = 0; i < dataOpeningHours3.length; i++) {
                        openingHours += `<p>${dataOpeningHours3[i]}</p>`;
                    }

                    let popupInformation = `
                    <a target="" href=${bank.dataset.link} style="outline: none">
                        <div class="popupInformation">
                            <h3>${bank.dataset.name}</h3>
                            <p><b>Adresse:</b></p>
                            <p> ${bank.dataset.address} </p>
                            <p> ${bank.dataset.postnumber} ${bank.dataset.city} </p>
                            <p>${openingHours}</p>
                            ${phoneHtml}
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 18" fill="none">
                                <path d="M16.6821 1L21.7976 6.1155C23.3597 7.6776 23.3597 10.2103 21.7976 11.7724L16.6821 16.8879" stroke="#1F1F1F" stroke-width="2" />
                                <line x1="23.832" y1="9.14954" x2="0.000255497" y2="9.14953" stroke="black" stroke-width="2" />
                            </svg>
                        </div>
                    </a>
                `;
                    const markerImage =
                        "https://www.andelskassen.dk/media/xlygek0s/marker.png";

                    const marker = new google.maps.Marker({
                        position: {
                            lat: Number(bank.dataset.long),
                            lng: Number(bank.dataset.lat)
                        },
                        map: this.map,
                        title: bank.dataset.city,
                        icon: markerImage
                    });

                    marker.addListener("click", function () {
                        infowindow.setContent(popupInformation);
                        this.map.panTo({
                            lat: Number(bank.dataset.long),
                            lng: Number(bank.dataset.lat)
                        });
                        infowindow.open({
                            anchor: marker,
                            map: this.map,
                            shouldFocus: true
                        });
                        const currentBank = document.getElementById(
                            bank.dataset.link
                        );
                        const topPos = currentBank.offsetTop;
                        document.querySelector(".left__column").scroll({
                            top: topPos,
                            left: 0,
                            behavior: "smooth"
                        });
                    });

                    bank.addEventListener("mouseover", function (e) {
                        infowindow.setContent(popupInformation);
                        infowindow.open({
                            anchor: marker,
                            map: this.map,
                            shouldFocus: true
                        });
                    });
                });
        });
    }

    init() {
        this.loadMap();
    }
}
